export const TrafficCone = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19.5 17.2077C19.4989 17.2079 19.4977 17.2078 19.4966 17.2079C19.471 17.0926 19.3708 17.0064 19.2508 17.0064C19.2439 17.0064 17.6317 17.0075 17.6317 17.0075L13.0817 5.92859C12.75 5.12062 12.2587 5 11.9955 5C11.7322 5 11.241 5.12062 10.9091 5.92859L6.35935 17.0075C6.35935 17.0075 4.78051 17.0079 4.78044 17.0081C4.77118 17.0071 4.76181 17.0064 4.75227 17.0064C4.61294 17.0064 4.5 17.1225 4.5 17.2657C4.5 17.2795 4.50337 19 4.50337 19H19.5L19.5 17.2077ZM10.6887 8.01502H13.3275L14.3031 10.3906H9.71311L10.6887 8.01502ZM7.45224 15.9568L8.43336 13.5678H15.5826L16.5637 15.9568H7.45224Z"
        fill="currentColor"
      />
    </svg>
  );
};
